import { Box, Paper, Stack, Typography } from "@mui/material";
import BackButton from "@quest_editor/components/Buttons/BackButton";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import Breadcrumb from "@quest_editor/components/Breadcrumb";
import PromotionTypeChip from "@quest_editor/components/Chips/PromotionTypeChip";
import PromotionStatusChip from "@quest_editor/components/Chips/PromotionStatusChip";
import { useQuestBySurveyId, usePromotion } from "@quest_editor/mocks";

const SurveyEditQuestion = () => {
  const { t } = useTranslation("questEditor");
  const { id: surveyId } = useParams<{ id: string }>();

  const { data: questData } = useQuestBySurveyId(surveyId);
  const quest = questData?.quest;

  const { data: promotionData } = usePromotion(quest?.promotionId);
  const promotion = promotionData?.promotion;

  // TODO: 実際のアンケートエディタURLに置き換える
  const editorUrl = "about:blank";

  if (!quest || !promotion) {
    return <Typography>{t("common.label.not_found")}</Typography>;
  }

  return (
    <Stack direction="column" spacing={3} sx={{ flex: 1, minHeight: 0 }}>
      <Stack
        direction="row"
        alignItems="flex-start"
        justifyContent="space-between"
      >
        <Stack direction="column" spacing={2} alignItems="flex-start">
          <Breadcrumb items={[{ label: promotion.name, to: `/quest_editor/promotion/${promotion.id}` }, { label: quest.name }]} />
          <Stack direction="row" spacing={1}>
            <PromotionTypeChip type={promotion.type} />
            <PromotionStatusChip status={promotion.status} />
          </Stack>
        </Stack>
      </Stack>

      <Paper
        elevation={0}
        sx={{
          border: 1,
          borderColor: "divider",
          flex: 1,
          minHeight: 500,
          overflow: "hidden",
        }}
      >
        <Box
          component="iframe"
          src={editorUrl}
          title="Survey Editor"
          sx={{
            width: "100%",
            height: "100%",
            border: "none",
          }}
        />
      </Paper>

      <BackButton
        component={Link}
        to={`/quest_editor/quest/${quest.id}`}
        sx={{ alignSelf: "flex-start" }}
      >
        {t("survey_edit_question.button.back")}
      </BackButton>
    </Stack>
  );
};

export default SurveyEditQuestion;
